import React, { useState } from 'react';
import axios from 'axios';
import { ArrowRight } from 'lucide-react';

export default function ContactForm() {
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [status, setStatus] = useState('');

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('Enviando…');
    try {
      await axios.post('/send-email', form);
      setStatus('Mensagem enviada. Retornamos em horário comercial.');
      setForm({ name: '', email: '', message: '' });
    } catch (err) {
      setStatus('Não foi possível enviar. Tente novamente ou ligue para (41) 3523-6600.');
    }
  };

  return (
    <form onSubmit={handleSubmit} className="form">
      <label className="field">
        <span>Nome</span>
        <input type="text" name="name" value={form.name} onChange={handleChange} required autoComplete="name" />
      </label>

      <label className="field">
        <span>E-mail</span>
        <input type="email" name="email" value={form.email} onChange={handleChange} required autoComplete="email" spellCheck={false} />
      </label>

      <label className="field">
        <span>Mensagem</span>
        <textarea
          name="message"
          value={form.message}
          onChange={handleChange}
          required
          rows="5"
          maxLength={300}
        />
        <div className="count">{form.message.length}/300</div>
      </label>

      <button type="submit" className="btn" disabled={status === 'Enviando…'}>
        Enviar mensagem
        <ArrowRight size={18} aria-hidden="true" />
      </button>
      {status && (
        <p className="form-status" role="status">
          {status}
        </p>
      )}
    </form>
  );
}
